import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { proceedingMembershipOptions } from '@/module/Nomen/ProceedingMembership/model/ProceedingMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ProceedingMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ProceedingMembershipSelectControl<T extends FieldValues>(
  props: ProceedingMembershipSelectControlProps<T>,
) {
  const { data, isLoading, isError } = useQuery(proceedingMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
